import React, { useState, useEffect } from 'react';
import { auth } from './firebase'; 
import { onAuthStateChanged, signOut } from 'firebase/auth';
import LoginPage from './pages/LoginPage';
import SalesPage from './pages/SalesPage';
import TartimPage from './pages/TartimPage';
import StockPage from './pages/StockPage';
import DriverPage from './pages/DriverPage'; 
import OrderPage from './pages/OrderPage'; 
import DevayKargoPage from './pages/DevayKargoPage'; 
import KargoOperasyon from './pages/KargoOperasyon'; 
import CustomerManager from './pages/CustomerManager';
import ProjectManager from './pages/ProjectManager';
import ExpensePage from './pages/ExpensePage';
// YENİ: Personel Yönetim Sayfası
import StaffManager from './pages/StaffManager';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [aktifSayfa, setAktifSayfa] = useState("order"); 

  const userEmail = user?.email?.toLowerCase().trim();
  const isAdmin = userEmail === "abbaskarayel@gmail.com";
  const isKargoSorumlusu = userEmail === "devaykargo@gmail.com" || userEmail === "kargo@gmail.com";

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      const email = currentUser?.email?.toLowerCase().trim();
      
      if (email === "abbaskarayel@gmail.com") {
        setAktifSayfa("order");
      } else if (email === "devaykargo@gmail.com" || email === "kargo@gmail.com") {
        setAktifSayfa("operasyon"); 
      } else {
        setAktifSayfa("driver");
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) return <div className="min-h-screen bg-slate-950 flex items-center justify-center text-white font-black uppercase tracking-widest italic">Yükleniyor...</div>;
  if (!user) return <LoginPage />; 

  return (
    <div className="min-h-screen bg-slate-950 text-white font-sans flex flex-col">
      
      {isAdmin && (
        <nav className="bg-slate-900 p-4 border-b border-slate-800 flex items-center justify-between sticky top-0 z-50 shadow-2xl">
          <div className="flex items-center gap-8">
            <div className="flex flex-col shrink-0">
                <span className="text-blue-500 font-black tracking-tighter text-xl leading-none uppercase italic">Aydın</span>
                <span className="text-[8px] text-slate-500 font-bold tracking-[0.3em] uppercase">Fabrika Paneli</span>
            </div>
            
            <div className="flex gap-2">
              
              {/* ÜRETİM GRUBU */}
              <div className="relative group py-2">
                <button className="flex items-center gap-2 px-4 py-2 rounded-xl font-bold text-xs text-slate-300 group-hover:bg-slate-800 group-hover:text-white transition-all uppercase tracking-tighter">
                  🏗️ Üretim <span className="text-[8px] opacity-50">▼</span>
                </button>
                <div className="absolute hidden group-hover:block top-full left-0 pt-2 w-56 z-50 animate-in fade-in zoom-in-95 duration-200">
                  <div className="bg-slate-800 border border-slate-700 shadow-2xl rounded-2xl p-2 overflow-hidden ring-1 ring-white/5">
                    <button onClick={() => setAktifSayfa("tartim")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] flex items-center justify-between transition-all ${aktifSayfa === 'tartim' ? 'bg-emerald-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      <span>⚖️ TARTIM KAYDI</span>
                    </button>
                  </div>
                </div>
              </div>

              {/* SATIŞ & SEVK GRUBU */}
              <div className="relative group py-2">
                <button className="flex items-center gap-2 px-4 py-2 rounded-xl font-bold text-xs text-slate-300 group-hover:bg-slate-800 group-hover:text-white transition-all uppercase tracking-tighter">
                  💰 Satış & Sevk <span className="text-[8px] opacity-50">▼</span>
                </button>
                <div className="absolute hidden group-hover:block top-full left-0 pt-2 w-56 z-50 animate-in fade-in zoom-in-95 duration-200">
                  <div className="bg-slate-800 border border-slate-700 shadow-2xl rounded-2xl p-2 overflow-hidden ring-1 ring-white/5">
                    <button onClick={() => setAktifSayfa("order")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] mb-1 transition-all ${aktifSayfa === 'order' ? 'bg-orange-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      🛒 YENİ SİPARİŞ
                    </button>
                    <button onClick={() => setAktifSayfa("satis")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] mb-1 transition-all ${aktifSayfa === 'satis' ? 'bg-blue-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      📋 MAĞAZA (TAKİP)
                    </button>
                    <button onClick={() => setAktifSayfa("operasyon")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] transition-all ${aktifSayfa === 'operasyon' ? 'bg-emerald-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      📦 KARGO OPERASYON
                    </button>
                  </div>
                </div>
              </div>

              {/* PROJELER & FİNANS GRUBU */}
              <div className="relative group py-2">
                <button className="flex items-center gap-2 px-4 py-2 rounded-xl font-bold text-xs text-blue-400 group-hover:bg-slate-800 group-hover:text-white transition-all uppercase tracking-tighter">
                  📊 Projeler & Finans <span className="text-[8px] opacity-50">▼</span>
                </button>
                <div className="absolute hidden group-hover:block top-full left-0 pt-2 w-56 z-50 animate-in fade-in zoom-in-95 duration-200">
                  <div className="bg-slate-800 border border-blue-900 shadow-2xl rounded-2xl p-2 overflow-hidden ring-1 ring-white/5">
                    <button onClick={() => setAktifSayfa("projeler")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] mb-1 transition-all ${aktifSayfa === 'projeler' ? 'bg-blue-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      🚀 PROJE YÖNETİMİ
                    </button>
                    <button onClick={() => setAktifSayfa("personel")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] mb-1 transition-all ${aktifSayfa === 'personel' ? 'bg-orange-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      👥 PERSONEL & HAKEDİŞ
                    </button>
                    <button onClick={() => setAktifSayfa("masraflar")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] transition-all ${aktifSayfa === 'masraflar' ? 'bg-red-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      💸 GENEL MASRAFLAR
                    </button>
                  </div>
                </div>
              </div>

              {/* YÖNETİM GRUBU */}
              <div className="relative group py-2">
                <button className="flex items-center gap-2 px-4 py-2 rounded-xl font-bold text-xs text-slate-300 group-hover:bg-slate-800 group-hover:text-white transition-all uppercase tracking-tighter">
                  ⚙️ Yönetim <span className="text-[8px] opacity-50">▼</span>
                </button>
                <div className="absolute hidden group-hover:block top-full left-0 pt-2 w-56 z-50 animate-in fade-in zoom-in-95 duration-200">
                  <div className="bg-slate-800 border border-slate-700 shadow-2xl rounded-2xl p-2 overflow-hidden ring-1 ring-white/5">
                    <button onClick={() => setAktifSayfa("musteriler")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] mb-1 transition-all ${aktifSayfa === 'musteriler' ? 'bg-blue-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      👥 MÜŞTERİ REHBERİ
                    </button>
                    <button onClick={() => setAktifSayfa("stok")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] mb-1 transition-all ${aktifSayfa === 'stok' ? 'bg-indigo-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      📦 STOK DURUMU
                    </button>
                    <button onClick={() => setAktifSayfa("kargo")} className={`w-full text-left px-4 py-3 rounded-lg font-bold text-[11px] transition-all ${aktifSayfa === 'kargo' ? 'bg-slate-600 text-white' : 'text-slate-200 hover:bg-slate-700'}`}>
                      🚛 ŞOFÖR ATAMA
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>
          
          <div className="flex items-center gap-4 shrink-0">
            <button onClick={() => signOut(auth)} className="text-red-500 text-[10px] font-black hover:underline uppercase italic">GÜVENLİ ÇIKIŞ</button>
          </div>
        </nav>
      )}

      {!isAdmin && (
        <div className="fixed top-4 right-4 z-[100]">
          <button onClick={() => signOut(auth)} className="bg-black/40 backdrop-blur-md text-white border border-white/10 px-4 py-2 rounded-full text-[10px] font-black uppercase italic">ÇIKIŞ</button>
        </div>
      )}

      <main className={`${isAdmin ? 'p-4 md:p-6 max-w-7xl mx-auto' : 'p-0'} w-full flex-1`}>
        {isKargoSorumlusu && <KargoOperasyon />}
        {!isAdmin && !isKargoSorumlusu && <DriverPage />}
        
        {isAdmin && (
          <>
            {aktifSayfa === "order" && <OrderPage />}
            {aktifSayfa === "operasyon" && <KargoOperasyon />} 
            {aktifSayfa === "satis" && <SalesPage />}
            {aktifSayfa === "tartim" && <TartimPage />}
            {aktifSayfa === "stok" && <StockPage />}
            {aktifSayfa === "kargo" && <DevayKargoPage />}
            {aktifSayfa === "musteriler" && <CustomerManager />}
            {aktifSayfa === "projeler" && <ProjectManager />}
            {aktifSayfa === "masraflar" && <ExpensePage />}
            {/* YENİ SAYFA RENDERI */}
            {aktifSayfa === "personel" && <StaffManager />}
          </>
        )}
      </main>
    </div>
  );
}

export default App;